// eslint-disable vue
import store from '@/state/store'
//import { meta } from '@babel/eslint-parser';

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      title: 'Login',
      beforeResolve(next) {
        if (store.getters.loggedIn) {
          next({ name: 'dashboard' })
          next()
        } else {
          next()
        }
      }
    },
    component: () => import('../views/login.vue')
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard.vue"),
  },
  {
    path: "/downlines",
    name: "downlines",
    meta: {
      title: "Downlines",
      authRequired: true,
    },
    component: () => import("../views/downlines.vue"),
  },
  {
    path: "/earnings",
    name: "earnings",
    meta: {
      title: "Earning Status",
      authRequired: true,
    },
    component: () => import("../views/earning.vue"),
  },
  {
    path: "/clients",
    name: "clients",
    meta: {
      title: "Clients",
      authRequired: true,
    },
    component: () => import("../views/clients.vue"),
  },
  {
    path: "/files",
    name: "files",
    meta: {
      title: "Files and Links",
      authRequired: true,
    },
    component: () => import("../views/files.vue"),
  },
  //Property Listing
  {
    path: '/property-listing/forms/add',
    name: 'add-listing',
    component: () => import('@/views/listing/listing-add.vue'),
  },
  {
    path: "/property-listing",
    name: "property-listing",
    meta: {
      title: "Property Listing",
      authRequired: true,
    },
    component: () => import("../views/property-listing.vue"),
  },
  {
    path: "/view-listing/:id",
    name: "view-listing",  // Add missing comma here
    meta: {
      title: "View Property Listing",
      authRequired: true,
    },
    component: () => import("../views/listing/listing-partner-view.vue"),
  },
  {
    path: "/update-listing/:id",  // Use :id to pass the property ID
    name: "update-listing",
    meta: {
      title: "Update Property Listing",
      authRequired: true,  // You can adjust the authentication requirement based on your needs
    },
    component: () => import("../views/listing/listing-partner-update.vue"),  // Adjust the path as needed
  },
  {
    path: "/approve-update-listing/:id",  // Use :id to pass the property ID
    name: "approve-update-listing",
    meta: {
      title: "Approve Update Property Listing",
      authRequired: true,  // You can adjust the authentication requirement based on your needs
    },
    component: () => import("../views/listing/listing-approve-update.vue"),  // Adjust the path as needed
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      title: "Profile",
      authRequired: true,
    },
    component: () => import("../views/profile.vue"),
  },
  {
    path: "/reset-email",
    name: "reset-email",
    meta: {
      title: "reset Email",
      authRequired: true,
    },
    component: () => import("../views/reset-password/reset-email.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    meta: {
      title: "Reset Password",
      authRequired: false,
    },
    component: () => import("../views/reset-password/reset-password.vue"),
  },
  {
    path: "/payouts",
    name: "payouts",
    meta: {
      title: "Payout",
      authRequired: true,
    },
    component: () => import("../views/payout.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    meta: {
      title: "forgot-password",
      authRequired: false,
    },
    component: () => import("../views/forgot-password.vue"),
  },
  {
    path: "/set-up-account",
    name: "set-up-account",
    meta: {
      title: "set-up-account",
      authRequired: true,
    },
    component: () => import("../views/set-up-account.vue")
  },
];
